import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable()
export class MobileGuard {
  constructor(
    private router: Router,
    private deviceService: DeviceDetectorService
  ) { }

  /**
   * Can activate the route only if the user uses a mobile device
   */
  canActivate() {
    if (!this.deviceService.isMobile()) {
      return true;
    } else {
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
